// extracted by mini-css-extract-plugin
export default {"container":"ic-double-right_container__3WPge"};